import { render, staticRenderFns } from "./AssignEntityReationshipDataWidget.vue?vue&type=template&id=a9641d64&scoped=true"
import script from "./AssignEntityReationshipDataWidget.vue?vue&type=script&lang=js"
export * from "./AssignEntityReationshipDataWidget.vue?vue&type=script&lang=js"
import style0 from "./AssignEntityReationshipDataWidget.vue?vue&type=style&index=0&id=a9641d64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9641d64",
  null
  
)

export default component.exports